import React from 'react'
import { IconProps } from '../types'

export default function DownArrowIcon({
    className = 'h-4 w-4',
    fill = 'currentColor',
    ...props
}: IconProps) {
    return (
        <svg
            width="6"
            height="10"
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M3.64271 9.33531C3.53944 9.44076 3.3994 9.5 3.25338 9.5C3.10736 9.5 2.96732 9.44076 2.86405 9.33531L0.66135 7.08531C0.56104 6.97922 0.50553 6.83713 0.50679 6.68964C0.50804 6.54216 0.56596 6.40108 0.66806 6.29678C0.77016 6.19249 0.90827 6.13334 1.05266 6.13205C1.19704 6.13077 1.33615 6.18747 1.44 6.28993L2.70271 7.57975V1.06262C2.70271 0.91344 2.76072 0.77036 2.864 0.66487C2.96727 0.55938 3.10733 0.50012 3.25338 0.50012C3.39943 0.50012 3.5395 0.55938 3.64277 0.66487C3.74604 0.77036 3.80406 0.91344 3.80406 1.06262V7.57975L5.06676 6.28993C5.17062 6.18747 5.30972 6.13077 5.45411 6.13205C5.59849 6.13334 5.73661 6.19249 5.83871 6.29678C5.94081 6.40108 5.99872 6.54216 6 6.68964C6.00123 6.83713 5.94573 6.97922 5.84542 7.08531L3.64271 9.33531Z"
                fill={fill}
            />
        </svg>
    )
}
